import cookie from 'react-cookies';

function headersWithToken() {

  const token = cookie.load('token');
  if ( !token ) { window.location = "/signin"; }
  //// return { Authorization: `Bearer ${ token }` }
  return { token: token }

}

export default headersWithToken;